import * as GETTERS from '@/store/constants/getters.js';

export const i18nPlugin = {
    install(Vue) {
        Vue.prototype.$i18n = function(template, variables) {
            return this.$store.getters[GETTERS.GET_TRANSLATION](template, variables);
        };
    },
};
